module.exports = __webpack_public_path__ + "img/CI.395d0c2b.svg";